import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSync = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.3125 8.4375H1.3125C0.5625 8.4375 0 7.875 0 7.125V1.3125C0 0.5625 0.5625 0 1.3125 0H4.40625C5.0625 0 5.625 0.5625 5.625 1.3125V7.21875C5.625 7.875 5.0625 8.4375 4.3125 8.4375Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6875 15H10.5938C9.84375 15 9.28125 14.4375 9.28125 13.6875V7.875C9.375 7.125 9.9375 6.5625 10.6875 6.5625H13.7812C14.4375 6.5625 15 7.125 15 7.875V13.7812C15 14.4375 14.4375 15 13.6875 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 14.0625C5.15625 14.0625 3 12.8438 1.78125 10.7812L3.375 9.84375C4.3125 11.25 5.8125 12.1875 7.5 12.1875V14.0625Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5312 5.15625C10.6875 3.75 9.1875 2.8125 7.5 2.8125V0.9375C9.84375 0.9375 12 2.15625 13.2188 4.21875L11.5312 5.15625Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconSync;
